import React, { useState } from "react";
import "./contact.css";
import {
  Form,
  useNavigation,
  useActionData,
  redirect,
  json,
} from "react-router-dom";
import Button from "../../components/button/Button";
import emailjs from "@emailjs/browser";

function Contact({ method, event }) {
  const navigation = useNavigation();
  const data = useActionData();
  const [isSending, setIsSending] = useState(false);
  const [sendSuccess, setSendSuccess] = useState(false);
  const isSubmmiting = navigation.state === "submitting";
  const [input, setInput] = useState({
    name: "",
    email: "",
    message: "",
  });

  const clearForm = () => {
    setInput({ name: "", email: "", message: "" });
  };

  const onChangeInput = (event) => {
    const value = event.target.value;
    const name = event.target.name;

    setInput((prev) => {
      return { ...prev, [name]: value };
    });
  };

  const sendMessage = () => {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const isEmailValid = regex.test(input.email);
    if (!isEmailValid) {
      return;
    }
    setIsSending(true);

    setTimeout(() => {
      setIsSending(false);
      setSendSuccess(true);
      clearForm();
    }, 1000);

    setTimeout(() => {
      setSendSuccess(false);
    }, 3000);
  };

  console.log(data);

  return (
    <div className="container-xxl mt-md-5 pt-5 h-100">
      <div className="contact-container my-auto vh-50 mt-5 d-flex flex-column flex-md-row">
        <div className="contact-info mt-5">
          <h2>Get in Touch</h2>
          <p>
            Fill out the form below, and I’ll get back to you within 24 hours.
          </p>
        </div>
        <Form
          className="col-md form-container w-md-50 w-100"
          method="post"
          onSubmit={sendMessage}>
          {data && data.errors && (
            <ul>
              {Object.values(data.errors).map((err) => (
                <li key={err}>{err}</li>
              ))}
            </ul>
          )}
          <div className="d-flex  flex-column w-md-50 w-100 align-items-center justify-content-center form-div">
            <p className="w-100 d-flex flex-column  justify-content-center">
              <label htmlFor="name" className="label">
                {" "}
                Name
              </label>
              <input
                type="text"
                defaultValue={event ? event.name : ""}
                className=" input"
                name="name"
                value={input.name}
                onChange={(e) => onChangeInput(e)}
                placeholder="Your name"
              />
            </p>
            <p className="w-100 d-flex flex-column justify-content-center">
              <label htmlFor="email" className="label">
                {" "}
                Email
              </label>
              <input
                type="text"
                defaultValue={event ? event.email : ""}
                className={`input  ${
                  data && data.errors && data.errors.email && "border-danger "
                }`}
                name="email"
                value={input.email}
                onChange={(e) => onChangeInput(e)}
                placeholder="exemple@mail.com"
              />
            </p>
            <p className="w-100 d-flex  flex-column justify-content-center ">
              <label htmlFor="message" className="label">
                Message
              </label>
              <textarea
                className=" ml-1 input"
                height="200"
                name="message"
                value={input.message}
                onChange={(e) => onChangeInput(e)}
                placeholder="Message..."
              />
            </p>
            {sendSuccess ? (
                <button className="success-btn">
                <i
                  className="bi bi-check"
                  style={{ fontSize: "26px", color: "#FD7272", paddingTop: "6px" }}></i>
              </button>
            ) : (
              <Button
                text={isSending ? "Sending..." : "Send"}
                disabled={isSubmmiting}
                icon={isSending ? undefined : "bi bi-arrow-right"}
                style={{ transition: 'all .35s;'}}
                ></Button>
            )}
          </div>
        </Form>
      </div>
    </div>
  );
}
export default Contact;

export async function action({ request, params }) {
  const data = await request.formData();
  const errors = {};
  const eventData = {
    fullName: data.get("name"),
    email: data.get("email"),
    message: data.get("message"),
  };

  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const isEmailValid = regex.test(eventData.email);

  if (!isEmailValid) {
    errors.email = "That doesn't look like an email address";
  }
  emailjs
    .send(
      "service_wy1dmtg",
      "template_ugwacia",
      {
        fullName: eventData.fullName,
        message: eventData.message,
        senderEmail: eventData.email,
      },
      "aNLg71BgIk2yf35Yt"
    )
    .then(
      function () {},
      function (error) {}
    )
    .finally(() => {
      setTimeout(() => {
        // setSendIsLoading(false);
        // clearForm();
      }, 2000);
    });

  if (Object.keys(errors).length) {
    return { errors };
  }
  return redirect("/contact");
}
